import * as Cookies from '../utils/cookies';
import axios from 'axios';

export async function userLeagues() {
  const token = Cookies.getToken();

  const res = await axios({
    method: 'GET',
    url: process.env.REACT_APP_API_URL + '/api/league/leagues/',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (res.status === 200) {
    return res.data.results;
  } else {
    return { error: res.status };
  }
}
